import * as Types from '../../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SearchHistoryQueryVariables = Types.Exact<{ [key: string]: never }>;

export type SearchHistoryQuery = {
  searchHistory: Array<{ __typename: 'SearchHistoryEntry'; guid: string; title: string }>;
};

export const SearchHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchHistory' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'guid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchHistoryQuery, SearchHistoryQueryVariables>;
